module.exports = "mutation UpdateEmployee($data:EmployeeInput!){updateEmployee(data:$data){__typename success}}"